import { BaseInjectorService } from 'src/app/base/base-service.injecter';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService extends BaseInjectorService {
  signedIn = false;
  constructor(
    public router: Router,
    ) {
    super();
    this.eventSevice.getAuthState().subscribe(async (data) => {
      if (data.loggedIn) {
        this.signedIn = true;
      } else {
        this.signedIn = false;
      }
    });
  }

  canActivate() {
    return this.signedIn;
  }
}
